import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

function Section2({products, subcategoryName, addToCart}) {

    useEffect(() => {
        let elemt = document.getElementById('listProducts');

        //hacer que baje o haga scroll abajo para ver los productos
        if (elemt != null) {
            
            elemt.scrollIntoView();
        }

    }, [products]);

    const handleClickAddItem = (item) => {

        addToCart(item);
    }

    return (
        <div className="section-001 pb-0">
            <div className="container">
                {
                    products.length > 0 ?
                        <>
                        <div id="listProducts" className="kreen-heading style-01">
                            <div className="heading-inner">
                                <h3 className="title">
                                    {subcategoryName} </h3>
                                <div className="subtitle">
                                    <p className='text-primary' style={{textAlign:'justify'}}><i className="fa fa-info-circle"></i> Los precios que se muestran son aproximados, pueden cambiar de acuerdo a su gramaje real. Por favor, para obtener mejor información de los precios, agregue los productos que desea al carrito y hacer click en el botón <b>COTIZAR</b> para ponerse en contacto con el vendedor.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="kreen-products style-04">
                            <div className="response-product product-list-grid row auto-clear equal-container better-height ">

                                {
                                    products.map((prod, index) => {

                                        return (
                                            <div className="product-item best-selling style-04 rows-space-30 col-bg-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-ts-6 post-28 product type-product status-publish has-post-thumbnail product_cat-light product_cat-chair product_cat-sofas product_tag-light product_tag-sock  instock sale featured shipping-taxable purchasable product-type-simple" key={index}>
                                                <div className="product-inner tooltip-top tooltip-all-top">
                                                    <div className="product-thumb">

                                                        {
                                                            /*<a className="thumb-link" href="#">
                                                                <img className="img-responsive"
                                                                    src={prod.url_img_product}
                                                                    alt="imgProd" width="270" height="350" />
                                                            </a>*/
                                                        }

                                                        <div className="thumb-link">
                                                            {
                                                                prod.url_img_product != null ?
                                                                <a href={`/product_detail/`+prod.dessProductId}>
                                                                    <img className="img-responsive"
                                                                        src={prod.url_img_product}
                                                                        alt="imgProd" width="270" height="350" />
                                                                </a>
                                                                :
                                                                <a href={`/product_detail/`+prod.dessProductId}>
                                                                    <img className="img-responsive"
                                                                    src="../assets/images/defaults/default-image-product.jpg"
                                                                    alt="imgProd" width="270" height="350" />
                                                                </a>
                                                            }
                                                        </div>
                                                        
                                                        {
                                                            /*
                                                            <div className="group-button">
                                                                <div className="add-to-cart">
                                                                    <a className="button product_type_simple add_to_cart_button ajax_add_to_cart" style={{cursor: 'pointer'}}>
                                                                        Agregar al carrito
                                                                    </a>
                                                                </div>
                                                                
                                                                <a href="#" className="button yith-wcqv-button">Quick View</a>
                                                                <div className="kreen product compare-button">
                                                                    <a href="#" className="compare button">Compare</a>
                                                                </div>
                                                                <div className="yith-wcwl-add-to-wishlist">
                                                                    <div className="yith-wcwl-add-button show">
                                                                        <a href="#" className="add_to_wishlist">Add to Wishlist</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            */
                                                        }

                                                    </div>
                                                    <div className="product-info">
                                                        <h3 className="product-name product_title">
                                                            <a>{prod.name_product}</a>
                                                        </h3>
                                                        <span className='text text-muted'>
                                                            {prod.description}
                                                        </span>
                                                        <br />
                                                        <span className="price">
                                                             
                                                            <ins>
                                                                <span className="kreen-Price-amount amount">
                                                                    <span className="kreen-Price-currencySymbol">$</span>
                                                                    {parseFloat(prod.price1).toFixed(2)}
                                                                </span>
                                                            </ins>
                                                        </span>
                                                        <br />
                                                        {
                                                            prod.dess_tipo_producto.tipoProductoId == 2 ?
                                                            <small className='text-info'>El precio final puede cambiar según el peso</small>
                                                            :
                                                            null
                                                        }
                                                        <br />
                                                        {
                                                            prod.dess_unidade === null ?
                                                            <span className='text text-primary'>
                                                                Unidad aún por definir
                                                            </span>
                                                            :
                                                            <span className='text text-primary'>
                                                                Por {prod.dess_unidade.unidad}
                                                            </span>
                                                        }
                                                    </div>

                                                    {
                                                        //<button type='button' onClick={()=>handleClickAddItem(prod)} className='btn btn-secondary'>AGREGAR AL CARRITO</button>
                                                    }

                                                </div>
                                            </div>
                                        )
                                    })
                                }

                            </div>
                            <div className="shop-all">
                                
                            </div>
                        </div>
                        </>
                    :

                        <div className='text-center'>
                            <h2>No hay productos a mostrar</h2>
                        </div>
                }
            </div>
        </div>
    );
}

export default Section2;